import { render } from "./CartPanel.vue?vue&type=template&id=d039535c&scoped=true"
import script from "./CartPanel.vue?vue&type=script&lang=js"
export * from "./CartPanel.vue?vue&type=script&lang=js"

import "./CartPanel.vue?vue&type=style&index=0&id=d039535c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d039535c"]])

export default __exports__